export default __webpack_public_path__ + "static/media/danhabu-logo-retina3@2x.e6028720.png";